import { SettingsService } from './shared/services/system/settings.service';
import { Component, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';

import { RoutePartsService } from './shared/services/system/route-parts.service';
import { ThemeService } from './shared/services/system/theme.service';

import { environment } from '@env/environment';
import { Logger } from '@app/shared/services/system/logger.service';

import { filter } from 'rxjs/operators';
import { AuthGuard } from '@shared/services/system/auth/auth.guard';
import { AppSelectCompanyService } from '@shared/services/system/app-select-company/app-select-company.service';
import { GlobalSettingService } from '@shared/services/system/global-setting.service';

import { TranslateService } from '@ngx-translate/core';
import {HttpCancelService} from '@shared/services/system/http-cancel.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  appTitle = 'Aims';
  pageTitle = '';

  constructor(
    public title: Title,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private routePartsService: RoutePartsService,
    private themeService: ThemeService,
    private renderer: Renderer2,
    private globalSettingService: GlobalSettingService,
    private selectCompanyService: AppSelectCompanyService,
    private auth: AuthGuard,
    private httpCancelService: HttpCancelService,
    private settingsService: SettingsService,
    public translateService: TranslateService
  ) {

  }

  ngOnInit() {
    this.onPageChange();
    this.translateService.addLangs(['en'])
    this.translateService.setDefaultLang('en');
    if (this.auth.isLogin()) {
      this.settingsService.all();
    }
    if (environment.production) {
      Logger.enableProductionMode();
    }
  }

  ngAfterViewInit() {
    this.themeService.applyMatTheme(this.renderer);
    setTimeout(() => {
      this.settingsService.initTranslation();
    }, 618 * 2);
  }

  onPageChange() {
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((routeChange: NavigationEnd) => {
      // this.httpCancelService.cancelPendingRequests();
      if (routeChange.url === '/') {
        if (this.globalSettingService.firstPageOptions.find(
          (option) => option.value === this.globalSettingService.getConfig('first_page')
        ) !== undefined) {
          this.router.navigate(['/' + this.globalSettingService.getConfig('first_page')]);
        }
      }
      let routeParts = this.routePartsService.generateRouteParts(this.activeRoute.snapshot);
      if (!routeParts.length) {
        return this.title.setTitle(this.appTitle);
      }
      // Extract title from parts;
      this.pageTitle = routeParts
        .reverse()
        .map((part) => part.title)
        .reduce((partA, partI) => {
          return `${partA} > ${partI}`
        });
      this.pageTitle += ` | ${this.appTitle}`;
      this.title.setTitle(this.pageTitle);
      if (this.auth.isLogin()) {
        this.checkUseCompanyIdIsSet();
      }
    });
  }

  checkUseCompanyIdIsSet() {
    if (!this.globalSettingService.config.useCompanyId) {
      this.selectCompanyService.show();
    }
  }

}
